/**
 * 조건부 클래스 이름 합치기.
 *
 * 취향분석 화면이 웹사이트(tastee.kr)에서 옮겨 오면서 함께 넘어온 쓰임이다.
 * 원래는 clsx + tailwind-merge 를 썼는데, 이 앱에는 둘 다 없고 **넘기는
 * 클래스가 전부 덧붙이는 것뿐**이라(mt-4, md:w-[320px] 같은) 충돌을 풀어줄
 * 필요가 없다. 의존성 둘을 더하는 대신 이 다섯 줄로 둔다.
 *
 * 나중에 같은 클래스를 덮어쓰는 쓰임이 생기면 그때 tailwind-merge 를 들인다.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ')
}

export default cn
